import { loadEnv } from './app/load_env_vars';

loadEnv(
  import.meta.env.MODE === 'development'
    ? '/apps/selfservice/src/assets/environment.js'
    : './environment.js'
)
  .then(() => {
    // Don't load the booststrap file until the environment variables are loaded
    import('./bootstrap');
  })
  .catch(() => {
    // Append error to url
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    url.searchParams.append('error', 'EnvImportFailed');
    window.history.pushState(null, '', url.toString());
  });
